import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  header = new HttpHeaders({
    Authorization:
      'Bearer ' +
      JSON.parse(localStorage.getItem(localStorage.getItem('azureauthtoken')))
        ?.secret,
  });
  insertscheme: any;
  initializeFormGroup: any;
  success: any;
  form: any;
  getGovtSchemes: any;
  manageMarket: any;
  manageCrop: any;
  manageUnit: any;
  getaccesslist;
  getMenuAccessControl;
  logout: any;
  getToken: any;

  constructor(private _http: HttpClient) {}

  getUserdetails(postdata) {
    return this._http.post(
      environment.devUrl + 'User/CheckUserExistorSaved',
      postdata,
      { headers: this.header }
    );
  }

  autoSuggestionUser(postdata){
    return this._http.get(`${environment.devUrl}User/GetUserName?Search=${postdata}`)
  }

  getAllUser(data) {
    return this._http.post(environment.devUrl + 'User/GetAllUser', data, {
      headers: this.header,
    });
  }
  getStates() {
    return this._http.get(environment.devUrl + 'Configuration/GetStates', {
      headers: this.header,
    });
  }

  getProductlist(cropId) {
    return this._http.get(
      environment.devUrl + `MarketRate/GetProductList?CropId=${cropId}`,
      { headers: this.header }
    );
  }

  getProductlistForHistorical() {
    return this._http.get(environment.devUrl + 'MarketRate/GetProductList', {
      headers: this.header,
    });
  }

  addMarketProduct(postData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/AddProductType',
      postData,
      { headers: this.header }
    );
  }

  addSubMarketProduct(postData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/AddSubProductType',
      postData,
      { headers: this.header }
    );
  }

  // getSubProductlist() {
  //   return this._http.get(environment.devUrl + "MarketRate/GetSubProductList", { headers: this.header })
  // }

  getAverageReview() {
    return this._http.get(
      environment.devUrl + 'InAppFeedback/GetAverageReview',
      { headers: this.header }
    );
  }

  getTotalCount() {
    return this._http.get(
      environment.devUrl + 'AskAnExpert/AskAnExpertTotalCount',
      { headers: this.header }
    );
  }

  getTotalTrackYourHarvest() {
    return this._http.get(
      environment.devUrl + 'Harvest/GetTotalTrackHarvestUsers',
      { headers: this.header }
    );
  }

  getGovernmentSchemeTotalCount() {
    return this._http.get(
      environment.devUrl + 'GovermentScheme/GetGovernmentSchemeTotalCount',
      { headers: this.header }
    );
  }

  postMarketRate(postData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/AddMarketRate',
      postData,
      { headers: this.header }
    );
  }

  postGovtScheme(postData) {
    return this._http.post(
      environment.devUrl + 'GovermentScheme/AddUpdateGovernmentSchemes',
      postData,
      { headers: this.header }
    );
  }
  postGovtSchemeCategory(postData) {
    return this._http.post(
      environment.devUrl + 'GovermentScheme/AddUpdateGovernmentSchemesCategory',
      postData,
      { headers: this.header }
    );
  }

  getCategorylist() {
    return this._http.get(environment.devUrl + 'GovermentScheme', {
      headers: this.header,
    });
  }
  getActiveCategory(postData) {
    return this._http.post(
      environment.devUrl + 'GovermentScheme/GetActiveCategory',
      postData,
      { headers: this.header }
    );
  }

  getGovtSchemeCategorylist(postData) {
    return this._http.post(
      environment.devUrl + 'GovermentScheme/GetGovernmentSchemesForCategory',
      postData,
      { headers: this.header }
    );
  }

  postdocumentVerify(postdata) {
    return this._http.post(
      environment.devUrl + 'User/DocumentVerify',
      postdata,
      { headers: this.header }
    );
  }

  postapplicationremainder(postdata) {
    return this._http.post(
      environment.devUrl + 'FertilizerReminder',
      postdata,
      { headers: this.header }
    );
  }
  sentapplicationremaindernotification(postdata) {
    return this._http.post(
      environment.devUrl +
        'FertilizerReminder/SendFertilizerReminderNotification',
      postdata,
      { headers: this.header }
    );
  }
  getGetFertilizerReminderCount() {
    return this._http.get(
      environment.devUrl + 'FertilizerReminder/GetFertilizerReminderCount',
      { headers: this.header }
    );
  }
  getFertilizerReminderlist(postdata) {
    return this._http.post(
      environment.devUrl + 'FertilizerReminder/GetFertilizerReminderList',
      postdata,
      { headers: this.header }
    );
  }

  getFeedbackList(postdata) {
    return this._http.post(
      environment.devUrl + 'InAppFeedback/GetInAppFeedbackList',
      postdata,
      { headers: this.header }
    );
  }
  getFeedbackListReport(postdata) {
    return this._http.post(
      environment.devUrl + 'InAppFeedback/GetInAppFeedbackListReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }
  getHarvestDetailReport(postdata) {
    return this._http.post(
      environment.devUrl + 'Harvest/HarvestDetailReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }

  getHarvestDetail(postdata) {
    return this._http.post(
      environment.devUrl + 'Harvest/HarvestDetail',
      postdata,
      { headers: this.header }
    );
  }
  GetHarvestCropDetails(postdata) {
    return this._http.post(
      environment.devUrl + 'Harvest/GetHarvestCropDetailsAdmin',
      postdata,
      { headers: this.header }
    );
  }
  postHarvestDetail(postData) {
    return this._http.post(
      environment.devUrl + 'Harvest/PostHarvestDetail',
      postData,
      { headers: this.header }
    );
  }
  getdocumentlist(postdata) {
    return this._http.post(
      environment.devUrl + 'UserDocument/GetUserDocumentList',
      postdata,
      { headers: this.header }
    );
  }

  getGovernmentSchemes(postdata) {
    return this._http.post(
      environment.devUrl + 'GovermentScheme/GetGovernmentSchemes',
      postdata,
      { headers: this.header }
    );
  }

  getuserprofile(postdata) {
    return this._http.post(
      environment.devUrl + 'User/GetUserProfileforAdmin',
      postdata,
      { headers: this.header }
    );
  }

  getAllUserpdf(postdata) {
    return this._http.post(
      environment.devUrl + 'User/GetUserReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }
  getAllUserdocumentpdf(postdata) {
    return this._http.post(
      environment.devUrl + 'User/GetDocumentUserReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }
  getAllUsergovtpdf(postdata) {
    return this._http.post(
      environment.devUrl + 'GovermentScheme/GetGovernmentSchemesReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }
  getAllUserFertilizerReminderpdf(postdata) {
    return this._http.post(
      environment.devUrl + 'FertilizerReminder/GetFertilizerReminderListReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }

  getallblogpdf(postdata) {
    return this._http.post(
      environment.devUrl + 'Blogs/SearchAndfilterAdminBlogsReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }
  getActiveBlogCategory(postdata) {
    return this._http.post(
      environment.devUrl + 'Blogs/GetActiveBlogCategory',
      postdata,
      { headers: this.header }
    );
  }
  getMarketPriceHistoricalData(postdata) {
    return this._http.post(
      environment.devUrl + 'MarketRate/GetMarketPriceHistoricalData',
      postdata,
      { headers: this.header }
    );
  }

  getMarketCount() {
    return this._http.get(environment.devUrl + 'MarketRate/GetMarketCount', {
      headers: this.header,
    });
  }

  getMarketReports(postdata) {
    return this._http.post(
      environment.devUrl + 'MarketRate/GetMarketPriceHistoricalDataReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }

  getUpdateMarketRate(postdata) {
    return this._http.post(
      environment.devUrl + 'MarketRate/UpdateMarketRate',
      postdata,
      { headers: this.header }
    );
  }
  patchgovtdata(id, postdata) {
    return this._http.patch(
      environment.devUrl + 'GovermentScheme/' + id,
      postdata,
      { headers: this.header }
    );
  }
  removegovtdata(postdata) {
    return this._http.post(
      environment.devUrl + 'GovermentScheme/RemoveGovernmentSchemes',
      postdata,
      { headers: this.header }
    );
  }
  removegovtCategorydata(postdata) {
    return this._http.post(
      environment.devUrl + 'GovermentScheme/RemoveGovernmentSchemesCategory',
      postdata,
      { headers: this.header }
    );
  }
  removeblogdata(postdata) {
    return this._http.post(environment.devUrl + 'Blogs/DeleteBlog', postdata, {
      headers: this.header,
    });
  }
  updateblogdata(postdata) {
    return this._http.post(environment.devUrl + 'Blogs/EditBlog', postdata, {
      headers: this.header,
    });
  }
  postblogdata(postdata) {
    return this._http.post(environment.devUrl + 'Blogs/PostBlog', postdata, {
      headers: this.header,
    });
  }
  getblogcount() {
    return this._http.get(environment.devUrl + 'Blogs/GetBlogsCount', {
      headers: this.header,
    });
  }
  getblogcategory() {
    return this._http.get(environment.devUrl + 'Blogs/GetBlogCategories', {
      headers: this.header,
    });
  }
  removeBlogCategory(deletePostData) {
    return this._http.post(
      environment.devUrl + 'Blogs/DeleteBlogCategory',
      deletePostData,
      { headers: this.header }
    );
  }
  getblogdetails(id: any) {
    return this._http.get(
      environment.devUrl + 'Blogs/GetBlogDetailsByID?id=' + id,
      { headers: this.header }
    );
  }
  getblogdata(postdata) {
    return this._http.post(
      environment.devUrl + 'Blogs/SearchAndfilterAdminBlogs',
      postdata,
      { headers: this.header }
    );
  }
  deletblogdata(postdata) {
    return this._http.post(
      environment.devUrl + 'Blogs/SearchAndfilterAdminBlogs',
      postdata,
      { headers: this.header }
    );
  }
  postBlogCategory(formdata) {
    return this._http.post(
      environment.devUrl + 'Blogs/AddUpdateBlogCategory',
      formdata,
      { headers: this.header }
    );
  }

  removeMarketRate(postdata) {
    return this._http.post(
      environment.devUrl + 'MarketRate/RemoveMarketRate',
      postdata,
      { headers: this.header }
    );
  }

  marketRateUpdate(data) {
    return this._http.post(
      environment.devUrl + 'MarketRate/UpdateMarketRate',
      data,
      { headers: this.header }
    );
  }

  bulkMarketRate(postdata) {
    return this._http.post(
      environment.devUrl + 'MarketRate/BulkMarketRate',
      postdata,
      { headers: this.header }
    );
  }

  getNewsListHistoricalData(postdata) {
    return this._http.post(
      environment.devUrl + 'News/GetNewsListHistoricalData',
      postdata,
      { headers: this.header }
    );
  }

  postNews(postdata) {
    return this._http.post(environment.devUrl + 'News/PostNews', postdata, {
      headers: this.header,
    });
  }

  removeNews(postdata) {
    return this._http.post(environment.devUrl + 'News/RemoveNews', postdata, {
      headers: this.header,
    });
  }

  updateNews(postdata) {
    return this._http.post(environment.devUrl + 'News/EditNews', postdata, {
      headers: this.header,
    });
  }

  exportNews(postdata) {
    return this._http.post(
      environment.devUrl + 'News/GetNewsListHistoricalDataReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }

  getAverageNews() {
    return this._http.get(environment.devUrl + 'News/GetAverageNews', {
      headers: this.header,
    });
  }

  imageuploadblog(postdata) {
    return this._http.post(
      environment.devUrl + 'Blogs/PostBlogImages',
      postdata,
      { headers: this.header }
    );
  }
  getuploadimage() {
    return this._http.get(environment.devUrl + 'Blogs/GetBlogImages', {
      headers: this.header,
    });
  }

  getStaticUserData() {
    return this._http.get(environment.devUrl + 'User/GetStaticUserData', {
      headers: this.header,
    });
  }

  getDocumentUserReport(postdata) {
    return this._http.post(
      environment.devUrl + 'User/GetDocumentUserReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }

  getTraderStaticData() {
    return this._http.get(environment.devUrl + 'User/GetTraderStaticData', {
      headers: this.header,
    });
  }

  deleteBlogImages(postdata) {
    return this._http.post(
      environment.devUrl + 'Blogs/DeleteBlogImages',
      postdata,
      { headers: this.header }
    );
  }

  postCommentdata(postdata) {
    return this._http.post(
      environment.devUrl + 'AskAnExpert/PostComment',
      postdata,
      { headers: this.header }
    );
  }

  postsurveydata(postdata) {
    return this._http.post(environment.devUrl + 'Survey/PostSurvey', postdata, {
      headers: this.header,
    });
  }
  updateSurveyData(postdata) {
    return this._http.post(environment.devUrl + 'Survey/EditSurvey', postdata, {
      headers: this.header,
    });
  }
  removeSurveydata(postdata) {
    return this._http.post(
      environment.devUrl + 'Survey/RemoveSurvey',
      postdata,
      { headers: this.header }
    );
  }
  getSurveyList(postdata) {
    return this._http.post(
      environment.devUrl + 'Survey/GetSurveyList',
      postdata,
      { headers: this.header }
    );
  }
  getSurveyReports(postdata) {
    return this._http.post(
      environment.devUrl + 'Survey/GetSurveyListReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }
  getSurveyDataHeader() {
    return this._http.get(environment.devUrl + 'Survey/GetSurveyHeader', {
      headers: this.header,
    });
  }

  getMarketHeader(postdata) {
    return this._http.post(
      environment.devUrl + 'MarketRate/GetMarketHeader',
      postdata,
      { headers: this.header }
    );
  }

  getGovernmentSchemesReports(postdata) {
    return this._http.post(
      environment.devUrl + 'GovermentScheme/GetGovernmentSchemesReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }

  updateGovernmentSchemes(postdata) {
    return this._http.post(
      environment.devUrl + 'GovermentScheme/UpdateGovernmentSchemes',
      postdata,
      { headers: this.header }
    );
  }
  getAskAnExpertHeader() {
    return this._http.get(
      environment.devUrl + 'AskAnExpert/GetAskAnExpertTotalCount',
      { headers: this.header }
    );
  }
  getAskAnExpertRecord(postdata) {
    return this._http.post(
      environment.devUrl + 'AskAnExpert/GetAskAnExpertRecord',
      postdata,
      { headers: this.header }
    );
  }

  // getTicketDetail(id) {
  //   return this._http.get(
  //     environment.devUrl + 'AskAnExpert/GetTicketDetails?id=' + id,
  //     { headers: this.header }
  //   );
  // }

  getTicketDetail(id) {
    return this._http.get(
      environment.devUrl + 'AskAnExpert/GetComment?sfparentId=' + id,
      { headers: this.header }
    );
  }
  // getAskAnExpertTicketDetails() {
  //   return this._http.get(environment.devUrl + "AskAnExpert/GetTicketDetails", { headers: this.header })
  // }
  getAskAnExpertReport(postdata) {
    return this._http.post(
      environment.devUrl + 'AskAnExpert/AskAnExpertReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }
  removeFertilizerReminder(postdata) {
    return this._http.post(
      environment.devUrl + 'FertilizerReminder/RemoveFertilizerReminder',
      postdata,
      { headers: this.header }
    );
  }
  getTrackHeader() {
    return this._http.get(environment.devUrl + 'Harvest/GetHeaderCount', {
      headers: this.header,
    });
  }

  editFertilizerReminder(postdata) {
    return this._http.post(
      environment.devUrl + 'FertilizerReminder/EditFertilizerReminder',
      postdata,
      { headers: this.header }
    );
  }

  GetAdminProducts(postdata) {
    return this._http.post(
      environment.devUrl + 'Product/GetAdminProducts',
      postdata,
      { headers: this.header }
    );
  }

  getAdminProductsReport(postdata) {
    return this._http.post(
      environment.devUrl + 'Product/GetAdminProductsReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }

  getAdminProductHeader() {
    return this._http.get(
      environment.devUrl + 'Product/GetAdminProductHeader',
      { headers: this.header }
    );
  }
  getMenuAccess(postdata) {
    return this._http.post(
      environment.devUrl + 'AccessControl/GetMenuAccessControl',
      postdata,
      { headers: this.header }
    );
  }
  postMenuAccess(postdata) {
    return this._http.post(
      environment.devUrl + 'AccessControl/PostMenuAccessControl',
      postdata,
      { headers: this.header }
    );
  }

  getAdminUser() {
    return this._http.get(environment.devUrl + 'User/GetAdminUserlist', {
      headers: this.header,
    });
  }
  getContactlist() {
    return this._http.get(environment.devUrl + 'ContactUs', {
      headers: this.header,
    });
  }
  postContactUsDetail(postdata) {
    return this._http.post(
      environment.devUrl + 'ContactUs/PostContactUs',
      postdata,
      { headers: this.header }
    );
  }
  syncSFServerDetail(postdata) {
    return this._http.post(
      environment.devUrl + 'ContactUs/SyncSFServerData',
      postdata,
      { headers: this.header }
    );
  }
  getTransactionCount() {
    return this._http.get(environment.devUrl + 'Transaction/TransactionCount', {
      headers: this.header,
    });
  }

  getAdminTransactions(postdata) {
    return this._http.post(
      environment.devUrl + 'Transaction/GetAdminTransactions',
      postdata,
      { headers: this.header }
    );
  }

  getAdminTransactionReport(postdata) {
    return this._http.post(
      environment.devUrl + 'Transaction/GetAdminTransactionReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }

  getUserVerificationHistory(postdata) {
    return this._http.post(
      environment.devUrl + 'UserDocument/UserVerificationHistory',
      postdata,
      { headers: this.header }
    );
  }

  getUserVerificationDocumentList(postdata) {
    return this._http.post(
      environment.devUrl + 'UserDocument/GetUserVerificationDocumentList',
      postdata,
      { headers: this.header }
    );
  }

  getTraderList() {
    return this._http.get(environment.devUrl + 'User/GetTraderList', {
      headers: this.header,
    });
  }

  getMenuList(postdata) {
    return this._http.post(
      environment.devUrl + 'AccessControl/GetMenuList',
      postdata,
      { headers: this.header }
    );
  }
  // new code for Admin panel Discussion board api methods
  // DiscussionBoardHeaderData
  getDiscussionBoardHeaderData() {
    return this._http.get(
      environment.devUrl + 'DiscussionBoard/GetDiscussionBoardHeader',
      { headers: this.header }
    );
  }

  // GetDiscussionBoardDataList
  getDiscussionBoardDataList(postdata) {
    return this._http.post(
      environment.devUrl + 'DiscussionBoard/GetPostList',
      postdata,
      { headers: this.header }
    );
  }

  // discussion board export report
  getDiscussionBoardDataListReport(postdata) {
    return this._http.post(
      environment.devUrl + 'DiscussionBoard/GetPostListReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }

  // view post details
  getViewPostDetail(postdata) {
    return this._http.post(
      environment.devUrl + 'DiscussionBoard/GetViewPostDetail',
      postdata,
      { headers: this.header }
    );
  }
  // creating new post question
  postCreatequestion(postdata) {
    return this._http.post(
      environment.devUrl + 'DiscussionBoard/CreateDiscussionBoardPost',
      postdata,
      { headers: this.header }
    );
  }
  // post new answer
  postNewanswer(postdata) {
    return this._http.post(
      environment.devUrl + 'DiscussionBoard/PostAnswer',
      postdata,
      { headers: this.header }
    );
  }

  closeAnswer(postdata) {
    return this._http.post(
      environment.devUrl + 'DiscussionBoard/ClosePost',
      postdata,
      { headers: this.header }
    );
  }

  // update post
  updateDBPost(
    postdata // updateDBPost()
  ) {
    return this._http.post(
      environment.devUrl + 'DiscussionBoard/UpdatePost',
      postdata,
      { headers: this.header }
    );
  }
  // delete post
  deleteDBPost(postdata) {
    return this._http.post(
      environment.devUrl + 'DiscussionBoard/DeletePost',
      postdata,
      { headers: this.header }
    );
  }
  // delete  DB answer
  deleteDBAnswer(postdata) {
    return this._http.post(
      environment.devUrl + 'DiscussionBoard/DeleteAnswer',
      postdata,
      { headers: this.header }
    );
  }
  // update DB answer
  updateDBAnswer(postdata) {
    return this._http.post(
      environment.devUrl + 'DiscussionBoard/UpdateAnswer',
      postdata,
      { headers: this.header }
    );
  }

  //*****************************/ phase 2 api list *****************************
  getVideoCategory() {
    return this._http.get(environment.devUrl + 'VideoLibrary/GetCategory', {
      headers: this.header,
    });
  }

  getAverageVideo() {
    return this._http.get(environment.devUrl + 'VideoLibrary/GetAverageVideo', {
      headers: this.header,
    });
  }

  getVideoList(postdata) {
    return this._http.post(
      environment.devUrl + 'VideoLibrary/Getvideo',
      postdata,
      { headers: this.header }
    );
  }
  postVideo(formdata) {
    return this._http.post(
      environment.devUrl + 'VideoLibrary/PostVideo',
      formdata,
      { headers: this.header }
    );
  }
  exportVideo(postdata) {
    return this._http.post(
      environment.devUrl + 'VideoLibrary/GetVideolibraryDataReport',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }
  editVideo(postdata) {
    return this._http.post(
      environment.devUrl + 'VideoLibrary/EditVideo',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }
  romoveVideo(postdata) {
    return this._http.post(
      environment.devUrl + 'VideoLibrary/RemoveVideo',
      postdata,
      { responseType: 'blob', headers: this.header }
    );
  }
  postCategory(formdata) {
    return this._http.post(
      environment.devUrl + 'VideoLibrary/PostCategory',
      formdata,
      { headers: this.header }
    );
  }
  removeVideoCategory(deletePostData) {
    return this._http.post(
      environment.devUrl + 'VideoLibrary/RemoveCategoryList',
      deletePostData,
      { headers: this.header }
    );
  }
  getActiveVideoCategory(postdata) {
    return this._http.post(
      environment.devUrl + 'VideoLibrary/GetActiveCategory',
      postdata,
      { headers: this.header }
    );
  }
  //****************rotational banner */

  rotaionalBanner(formData) {
    return this._http.post(
      environment.devUrl + 'RotationBanner/PostBannerImages',
      formData,
      { responseType: 'blob', headers: this.header }
    );
  }
  getrotationalBanner() {
    return this._http.get(
      environment.devUrl + 'RotationBanner/GetBannerImages',
      { headers: this.header }
    );
  }
  removeRotationalBanner(deleteRotationalBanner) {
    return this._http.post(
      environment.devUrl + 'RotationBanner/RemoveBannerList',
      deleteRotationalBanner,
      { headers: this.header }
    );
  }

  //*******************************market rate update ********************************* */
  //: 1 market name drop down list
  getMarketlist() {
    return this._http.get(environment.devUrl + 'MarketRate/GetMarketList', {
      headers: this.header,
    });
  }
  getCropList() {
    return this._http.get(environment.devUrl + 'MarketRate/GetCropList', {
      headers: this.header,
    });
  }
  getSubProductType(ProductTypeCode: any) {
    return this._http.get(
      environment.devUrl +
        `MarketRate/GetSubProductTypeList?ProductTypeCode=${ProductTypeCode}`,
      { headers: this.header }
    );
  }

  getSubProductTypeForHistorical() {
    return this._http.get(
      environment.devUrl + 'MarketRate/GetSubProductTypeList',
      { headers: this.header }
    );
  }

  addManageCrop(manageCropPostData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/AddUpdateMarketRateCrop',
      manageCropPostData,
      { headers: this.header }
    );
  }
  removeManageCrop(deleteCropPostData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/RemoveCropList',
      deleteCropPostData,
      { headers: this.header }
    );
  }

  getUnitList() {
    return this._http.get(environment.devUrl + 'MarketRate/GetUnitList', {
      headers: this.header,
    });
  }
  removeManageUnit(deletePostData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/RemoveUnitList',
      deletePostData,
      { headers: this.header }
    );
  }
  addManageUnit(manageUnitPostData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/AddUpdateUnitList',
      manageUnitPostData,
      { headers: this.header }
    );
  }
  addManageMarket(manageMarketPostData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/AddUpdateMarketList',
      manageMarketPostData,
      { headers: this.header }
    );
  }
  removeManageMarket(deletePostData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/RemoveMarket',
      deletePostData,
      { headers: this.header }
    );
  }
  getActiveMarket(postdata) {
    return this._http.post(
      environment.devUrl + 'MarketRate/GetActiveMarket',
      postdata,
      { headers: this.header }
    );
  }
  getActiveCrop(postdata) {
    return this._http.post(
      environment.devUrl + 'MarketRate/GetActiveCrop',
      postdata,
      { headers: this.header }
    );
  }

  deleteProduct(postData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/RemoveProductType',
      postData,
      { headers: this.header }
    );
  }

  deleteSubProduct(postData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/RemoveSubProductType',
      postData,
      { headers: this.header }
    );
  }

  getActiveProduct(postdata) {
    return this._http.post(
      environment.devUrl + 'MarketRate/GetActiveProductType',
      postdata,
      { headers: this.header }
    );
  }

  getActiveSubProduct(postdata) {
    return this._http.post(
      environment.devUrl + 'MarketRate/GetActiveSubProductType',
      postdata,
      { headers: this.header }
    );
  }
  getActiveUnit(postdata) {
    return this._http.post(
      environment.devUrl + 'MarketRate/GetActiveUnit',
      postdata,
      { headers: this.header }
    );
  }

  addHarvest(postData) {
    return this._http.post(
      environment.devUrl + 'Harvest/PostHarvestDataAdmin',
      postData,
      { headers: this.header }
    );
  }

  postHarvestCrop(postData) {
    return this._http.post(
      environment.devUrl + 'Harvest/PostHarvestCrop',
      postData,
      { headers: this.header }
    );
  }

  getHarvestCropList() {
    return this._http.get(
      environment.devUrl + 'Harvest/GetHarvestCropListAdmin',
      { headers: this.header }
    );
  }

  deleteHarvestCrop(postData) {
    return this._http.post(
      environment.devUrl + 'Harvest/RemoveCropList',
      postData,
      { headers: this.header }
    );
  }

  getActiveHarvestCrop(postData) {
    return this._http.post(
      environment.devUrl + 'Harvest/GetActiveCrop',
      postData,
      { headers: this.header }
    );
  }

  // Need to change endPoint
  getDominateMarketData(postData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/GetDominantMarketPrice',
      postData,
      { headers: this.header }
    );
  }

  getActiveDominate(postData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/GetActiveDominant',
      postData,
      { headers: this.header }
    );
  }

  GetToggleStatusInDominate(postData) {
    return this._http.post(
      environment.devUrl + 'MarketRate/GetToggleStatus',
      postData,
      { headers: this.header }
    );
  }

  blogsUpdateBlogPriority(postData) {
    return this._http.post(
      environment.devUrl + 'Blogs/UpdateBlogPriority',
      postData,
      { headers: this.header }
    );
  }

  getVideoPriorityList() {
    return this._http.get(environment.devUrl + 'VideoLibrary/GetPriorityList', {
      headers: this.header,
    });
  }

  updateVideoPriority(postData) {
    return this._http.post(
      environment.devUrl + 'VideoLibrary/UpdateBlogPriority',
      postData,
      { headers: this.header }
    );
  }

  getBlogPriority() {
    return this._http.get(environment.devUrl + 'Blogs/GetPriorityList', {
      headers: this.header,
    });
  }
}
